import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from '@yuno/sdk-web-core/dist/ui'

export const Container = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'block' : 'none')};
`

export const TotalContent = styled.div`
  text-align: center;
  padding: 24px;
`

export const TotalTitle = styled.p`
  ${({ theme }) => css(theme.typographys.base.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const TotalPrice = styled.p`
  ${({ theme }) => css(theme.typographys['3xl'].bold)};
  color: ${({ theme }) => theme.colors.neutrals.b};
`

export const ButtonPay = styled(Button)`
  border-radius: 10px;
  margin-top: 16px;
  margin-bottom: 16px;
`
